import React from 'react';

const HorizontalDivider = () => {
  return <div className="bg-gray-100 w-full border-b" />;
};

export default HorizontalDivider;
